const languagesTypes = [
  { id: 1, label: 'french' },
  { id: 2, label: 'english' },
];

export default languagesTypes;
